// extracted by mini-css-extract-plugin
export default {"wrapper":"Ld","form":"Md","label":"Nd","asterisk":"Od","smallprint":"Pd","noMargin":"Qd","success":"Rd","circle":"Sd"};